const SettingsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || '#fff'}
      d="M17.282 8.638c-1.628 0-2.294-1.151-1.484-2.563a1.706 1.706 0 0 0-.63-2.33l-1.556-.89c-.711-.423-1.629-.172-2.051.54l-.1.17c-.809 1.412-2.14 1.412-2.959 0l-.099-.17a1.476 1.476 0 0 0-2.033-.54l-1.556.89a1.717 1.717 0 0 0-.63 2.339c.819 1.403.153 2.554-1.475 2.554-.935 0-1.709.765-1.709 1.71v1.583c0 .935.765 1.709 1.71 1.709 1.627 0 2.293 1.151 1.474 2.564a1.706 1.706 0 0 0 .63 2.33l1.556.89c.711.423 1.628.171 2.051-.54l.1-.17c.809-1.413 2.14-1.413 2.959 0l.099.17c.422.711 1.34.963 2.05.54l1.557-.89a1.708 1.708 0 0 0 .63-2.33c-.819-1.413-.153-2.564 1.475-2.564.935 0 1.709-.765 1.709-1.71v-1.582a1.728 1.728 0 0 0-1.718-1.71Zm-7.287 5.425a2.93 2.93 0 0 1-2.923-2.924 2.93 2.93 0 0 1 2.923-2.923 2.93 2.93 0 0 1 2.924 2.923 2.93 2.93 0 0 1-2.924 2.924Z"
    />
  </svg>
)
export default SettingsIcon
